import { api } from "../api/callApi";
import { urlServer } from "../api/v1";
import { TREATMENT_TYPE } from "../varibles/constants";
import { ICombineTreatment } from "../varibles/interface";

const urlBase = urlServer + '/combine'

export const CombineService = {
    gets: () => api.get<ICombineTreatment[]>(urlBase + '/types'),
    create: (body: ICreateCombine) => api.post<ICombineTreatment>(urlBase + '/type', body),
    update: (body: IUpdateCombine) => api.put<ICombineTreatment>(urlBase + '/type', body),
    delete: (id: string) => api.deleteBody(urlBase + '/type', { id }),
    elements: () => api.get<TREATMENT_TYPE[]>(urlBase + '/element')
}

interface ICreateCombine {
    name: string
    sub_types: any[]
}

interface IUpdateCombine {
    id: string
    name: string
    treatment_sub_types: any[]
}